import React from 'react'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')
require('../style/scss/custom/main.scss')

require('../style/css/custom/components/navigation.css')
require('../style/css/custom/cssAnimations.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')
// require('../js_animations/navResets.js')




const Navigation = ({
  logo_blue_PNG_70,
  mouse_graphic_icon,

  logoLinkClicked,
  appsLinkClicked,
  motionGraphicsLinkClicked,
  digitalArtLinkClicked,
  musicLinkClicked,

}) => (

<div> {/* enclosure */}

  <a href="#_bottom">
    <div className="mouse_graphic" id="mouse_graphic_1">
      <img className="mouse_graphic_icon" src={mouse_graphic_icon} alt="mouse_graphic_icon" />
    </div>
  </a>


  <div className="navigation_main" id="navigation_main">
  {/* NOTE: .navigation_main is only used for the larger responsive elements (pinned_nav_bar + nav_links) */}


    {/*
      NAV BAR 1: RESPONSIVE (min-width: 1178)
    */}

    <div className="pinned_nav_bar">


      <div className="menu_links_header menu_link_header_AboutMe">
        ABOUT ME
      </div>


      <div className="menu_links_header menu_link_header_Apps">
        APPS
      </div>



      <div className="menu_links_header menu_link_header_MotionGraphics">
        MOTION GRAPHICS
      </div>



      <div className="menu_links_header menu_link_header_DigitalArt">
        DIGITAL ART
      </div>



      <div className="menu_links_header menu_link_header_Music">
        MUSIC
      </div>



      <div id="menu_link_logo_1">
        <a className="links-decoration_none _AboutMeClicked" href="#_AboutMe"><img src={logo_blue_PNG_70} alt="logo_blue"/></a>
      </div>

      <a href="#_Apps">
        <div className="menu_links_responsive__1" id="menu_link_Apps_r1">
          APPS
        </div>
      </a>
      <a href="#_MotionGraphics">
        <div className="menu_links_responsive__1" id="menu_link_MotionGraphics_r1">
          MOTION GRAPHICS
        </div>
      </a>
      <a href="#_DigitalArt">
        <div className="menu_links_responsive__1" id="menu_link_DigitalArt_r1">
          DIGITAL ART
        </div>
      </a>
      <a href="#_Music">
        <div className="menu_links_responsive__1" id="menu_link_Music_r1">
          MUSIC
        </div>
      </a>

    </div> {/* pinned_nav_bar */}




    {/*
      NAV "BUBBLE" GRAPHICS: RESPONSIVE (min-width: 1178)
    */}

    <a href="#_Apps" className="nav_links nav_links_responsive__1" id="link_Apps">
      <div className="link_container">
        APPS
      </div>
      <div className="scrollMarker"></div>
    </a>

    <a href="#_MotionGraphics" className="nav_links nav_links_responsive__1" id="link_MotionGraphics">
      <div className="link_container">
        MOTION GRAPHICS
      </div>
      <div className="scrollMarker"></div>
    </a>

    <a href="#_DigitalArt" className="nav_links nav_links_responsive__1" id="link_DigitalArt">
      <div className="link_container">
        DIGITAL ART
      </div>
      <div className="scrollMarker"></div>
    </a>

    <a href="#_Music" className="nav_links nav_links_responsive__1" id="link_Music">
      <div className="link_container">
        MUSIC
      </div>
      <div className="scrollMarker"></div>
    </a>
    <div className="navigation_scrollMarker scrollMarker"></div>

  </div> {/* navigation_main */}



  <div className="pinned_nav_bar_2">
{
    // NOTE: .pinned_nav_bar_2 contains nav bars 2 AND 3 
}


    <div id="menu_link_logo_2">
      <a href="#_AboutMe" className="_AboutMeClicked"><img src={logo_blue_PNG_70} alt="logo_blue"/></a>
    </div>



    {/*
      NAV BAR 2: RESPONSIVE (max-width: 1177)
    */}


    {/*
      Menu Link Headers
        (the rotating headings at the center)
    */}

{    //
    // <div className="menu_headers_container">
}

    <div className="menu_links_header">

      <div className=" menu_link_header_AboutMe">
        ABOUT ME
      </div>


      <div className=" menu_link_header_Apps">
        APPS
      </div>



      <div className=" menu_link_header_MotionGraphics">
        MOTION GRAPHICS
      </div>



      <div className=" menu_link_header_DigitalArt">
        DIGITAL ART
      </div>



      <div className=" menu_link_header_Music">
        MUSIC
      </div>

    </div>




{
    // </div> menu_headers_container
}

    {/*
      Menu Links
        (the static links on the right)
    */}

    <div className="menu_links_responsive__2_container">

      <a href="#_Apps">
        <div className="menu_links_responsive__2" id="menu_link_Apps_r2">
          APPS
        </div>
      </a>

      <a href="#_MotionGraphics">
        <div className="menu_links_responsive__2" id="menu_link_MotionGraphics_r2">
          MOTION GRAPHICS
        </div>
      </a>

      <a href="#_DigitalArt">
        <div className="menu_links_responsive__2" id="menu_link_DigitalArt_r2">
          DIGITAL ART
        </div>
      </a>

      <a href="#_Music">
        <div className="menu_links_responsive__2" id="menu_link_Music_r2">
          MUSIC
        </div>
      </a>
    </div>



    {/*
      NAV BAR 3: RESPONSIVE (max-width: 767)
    */}


    <div className="menu_links_responsive__3_container">

      <a href="#_Apps">
        <div className="menu_links_responsive__3" id="menu_link_Apps_r3">
          APPS
        </div>
      </a>

      <a href="#_MotionGraphics">
        <div className="menu_links_responsive__3" id="menu_link_MotionGraphics_r3">
          MOTION GRAPHICS
        </div>
      </a>

      <a href="#_DigitalArt">
        <div className="menu_links_responsive__3" id="menu_link_DigitalArt_r3">
          DIGITAL ART
        </div>
      </a>

      <a href="#_Music">
        <div className="menu_links_responsive__3" id="menu_link_Music_r3">
          MUSIC
        </div>
      </a>

    </div>


  </div> {/* .pinned_nav_bar_2 */}

  <div className="navigation_scrollMarker scrollMarker"></div>

</div>

)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation.js